import type CreativeSDK from '@cesdk/cesdk-js';
import { GQLProductSideFragment, GQLProductSideSideType } from '@theprintbar/graphql';
import { getBackground, getPage } from './block';

export async function switchToSide(editor: CreativeSDK, newSide: GQLProductSideSideType, productSide?: GQLProductSideFragment) {
	const newBackground = getBackground(editor, newSide);
	const newPage = getPage(editor, newSide);

	if (!newBackground || !newPage) throw `Could not find background or page for side ${newSide}`;

	//Make all sides invisible
	Object.values(GQLProductSideSideType).forEach(side => {
		const background = getBackground(editor, side);
		if (side !== newSide && background) {
			editor.engine.block.setVisible(background, false);
		}
	});
	editor.engine.block.findAllSelected().forEach(selectedId => {
		editor.engine.block.setSelected(selectedId, false);
	});
	editor.engine.block.setVisible(newBackground, true);
	editor.engine.block.setScopeEnabled(newBackground, 'editor/select', false);
	editor.engine.block.setScopeEnabled(newPage, 'editor/select', false);
	await editor.unstable_switchPage(newPage);

	if (!!productSide?.editorZoom) {
		editor.engine.scene.setZoomLevel(productSide.editorZoom / 100);
	} else {
		await editor.engine.scene.zoomToBlock(newBackground);
		//Zoom in a bit
		let zoom = editor.engine.scene.getZoomLevel() * 1.4;
		//Round to a 2 decimal place
		zoom = Math.round(zoom * 100) / 100;
		editor.engine.scene.setZoomLevel(zoom);
	}

	return;
}
